export default __webpack_public_path__ + "fonts/tpl_1.11c8f3ef3aaca205344a1eb3b36bbde4.png";